import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import LandingHeader from "./sections/LandingHeader.jsx";
import LandingNav from "./sections/LandingNav.jsx";
import LandingFooter from "./sections/LandingFooter.jsx";
import "../../styles/new-landing.css";

const AboutSulhafaShop = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir && i18n.dir() === "rtl";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <LandingHeader />
      <LandingNav />
      <div className={`about-shop-container ${isRTL ? "rtl" : "ltr"}`}>
        <div className="about-shop-content">
          <div className="about-shop-text">
            <h1 className="about-shop-title">{t('aboutShop.header.title')}</h1>
            <p className="about-shop-desc">
              {t('aboutShop.header.description').split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < t('aboutShop.header.description').split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          </div>
          <div className="about-shop-image">
            <img src="/images/Sulhafa-Shopping.png" alt="Sulhafa Shop Mascot" />
          </div>
        </div>

        {/* How We're Different Section */}
        <div className="shop-features-section">
          <h2 className="shop-features-title">{t('aboutShop.features.title')}</h2>
          <p className="shop-features-desc">
            {t('aboutShop.features.subtitle')}
          </p>
          <div className="shop-features-cards">
            <div className="shop-feature-card">
              <div className="shop-feature-icon" style={{ background: "#ff6b35" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="17" r="1" fill="#fff" />
                  <rect x="8" y="4" width="8" height="4" rx="2" fill="#fff" />
                </svg>
              </div>
              <h3 className="shop-feature-card-title">{t('aboutShop.features.smartShopping.title')}</h3>
              <p className="shop-feature-card-desc">
                {t('aboutShop.features.smartShopping.description')}
              </p>
            </div>
            <div className="shop-feature-card">
              <div className="shop-feature-icon" style={{ background: "#19c37d" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#fff" />
                </svg>
              </div>
              <h3 className="shop-feature-card-title">{t('aboutShop.features.integratedServices.title')}</h3>
              <p className="shop-feature-card-desc">
                {t('aboutShop.features.integratedServices.description')}
              </p>
            </div>
            <div className="shop-feature-card">
              <div className="shop-feature-icon" style={{ background: "#2a8ad2" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="8.5" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M20 8v6M23 11l-3 3-3-3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="shop-feature-card-title">{t('aboutShop.features.jobCreation.title')}</h3>
              <p className="shop-feature-card-desc">
                {t('aboutShop.features.jobCreation.description')}
              </p>
            </div>
          </div>
        </div>

        {/* User Benefits Section */}
        <div className="shop-benefits-section">
          <h2 className="shop-benefits-title">{t('aboutShop.benefits.title')}</h2>

          <div className="shop-benefits-cards">
            {/* Pet Guardians */}
            <div className="shop-benefit-card guardians">
              <div className="shop-benefit-icon" style={{ background: "#8548a8" }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#fff" strokeWidth="2" />
                  <circle cx="12" cy="7" r="4" stroke="#fff" strokeWidth="2" />
                  <path d="M12 14l2 2 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>{t('aboutShop.benefits.petGuardians.title')}</h3>
              <p>{t('aboutShop.benefits.petGuardians.description')}</p>
            </div>

            {/* Secondhand Marketplace */}
            <div className="shop-benefit-card">
              <div className="shop-benefit-icon" style={{ background: "#27ae60", fontSize: "24px" }}>♻️</div>
              <h3>{t('aboutShop.additionalFeatures.secondhand.title')}</h3>
              <p>{t('aboutShop.additionalFeatures.secondhand.description')}</p>
            </div>

            {/* Specialized Delivery */}
            <div className="shop-benefit-card">
              <div className="shop-benefit-icon" style={{ background: "#3498db", fontSize: "24px" }}>🚚</div>
              <h3>{t('aboutShop.additionalFeatures.delivery.title')}</h3>
              <p>{t('aboutShop.additionalFeatures.delivery.description')}</p>
            </div>

            {/* Secure & Simple */}
            <div className="shop-benefit-card">
              <div className="shop-benefit-icon" style={{ background: "#f39c12", fontSize: "24px" }}>🔒</div>
              <h3>{t('aboutShop.additionalFeatures.secure.title')}</h3>
              <p>{t('aboutShop.additionalFeatures.secure.description')}</p>
            </div>
          </div>
        </div>

        {/* Medical Separation Section */}
        <div className="shop-medical-section">
          <div className="shop-medical-content">
            <h2 className="shop-medical-title">{t('aboutShop.medical.title')}</h2>
            <p className="shop-medical-desc">
              {t('aboutShop.medical.description').split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index < t('aboutShop.medical.description').split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="shop-closing-section">
          <div className="shop-closing-content">
            <h2 className="shop-closing-title">{t('aboutShop.closing.title')}</h2>
            <h3 className="shop-closing-subtitle">{t('aboutShop.closing.subtitle')}</h3>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default AboutSulhafaShop;
